import React from "react";
import moment from "moment";
import PieChart from "../ReactChart/PieChart";
import LineChart from "../ReactChart/LineChart";
import BarChart from "../ReactChart/BarChart";
import "./style.css"
import VarBarChart from "../ReactChart/VarBarChart";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { Button, Spinner } from "@public/ui-toolkit";

const ReportTable = ({ reportExtractData, id, isEmpty, RiskReportType, reportName, fundName, downloadLoading, downloadFile }) => {
  let color = true;
  const getColor = (level) => {
    if (level == 1) {
      color = !color;
    }
    if (level === 0 && !color) {
      return '#2db399';
    }
    else if (level == 0 && color) {
      return '#fff';
    }
    else if (level >= 1 && color) {
      return '#B1ecd5';
    } else {
      return '#fff';
    }
  };
  return (
    <div >
      {!isEmpty(reportExtractData) ? (
        <TransformWrapper
          wheel={{ disabled: true }}
          pinch={{ disabled: true }}
          doubleClick={{ disabled: true }}
          zoomAnimation={{ disabled: true }}
          alignmentAnimation={{ disabled: true }}
          velocityAnimation={{ disabled: true }}
          limitToBounds={true}
          centerZoomedOut={true}
          centerOnInit={true}
        >
          {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
            <React.Fragment>
              <div style={{
                padding: "0px", marginBottom: "10px",
                textAlign: 'center',
                height: "30px"
              }}>
                <div>
                  <Button
                    btnName="+"
                    btnType="primary"
                    onClick={() => zoomIn(0.1)}
                    btnStyle={{ margin: "0px", height: "30px" }}
                  />
                  
                  <Button
                    type="primary"
                    btnName={(rest.state.scale * 100).toFixed(0) + "%"}
                    btnStyle={{ margin: "0px", padding: '0px', padding: "5px 10px 5px 10px", height: "30px" }}
                  />
                  
                  <Button
                    btnName="-"
                    btnType="primary"
                    onClick={() => zoomOut(0.1)}
                    btnStyle={{ margin: "0px", height: "30px", padding: "5px 10px 5px 10px" }}
                  />

                  <div style={{ float: 'right', marginRight: "20px" }}>
                    <Button
                      type="primary"
                      btnName={downloadLoading ? <Spinner /> : "Download File"}
                      btnStyle={{ margin: "0px", padding: '0px', padding: "5px 10px 5px 10px", height: "30px" }}
                      onClick={downloadFile}
                    />
                  </div>
                </div>
              </div>
              <TransformComponent>
                <div className="hf-card2-body px-0 pb-0 border">
                  <div className="hf-table" id={id} style={{ width: "100%" }}>

                    <div className="col-lg-12">
                      <div className="row">
                        <div style={{ backgroundColor: "#122e47", fontSize: "20px", }}>
                          <h3 style={{ marginLeft: "40px", color: "white", padding: "10px 0px" }}>
                            <b>{reportName}</b>
                            <span style={{ float: 'right', fontSize: "16px", padding: "10px 10px 0px 0px" }}>Powered by MSCI</span>
                          </h3>
                        </div>
                        <div style={{ backgroundColor: "white", height: "10px" }}></div>
                        <div style={{ backgroundColor: "#122e47", height: "10px" }}></div>
                        <div style={{ backgroundColor: "white", height: "10px" }}></div>
                        <div className="col-lg-4" >
                          {(() => {
                            if (reportExtractData?.riskReportType == RiskReportType[0]?.value) { //Exposure
                              return (
                                <div>
                                  <PieChart reportExtractData={reportExtractData} />
                                </div>
                              )
                            } else if (reportExtractData?.riskReportType == RiskReportType[1]?.value) { //VAR
                              return (
                                <div>
                                  <VarBarChart reportExtractData={reportExtractData} fundName={fundName} />
                                </div>
                              )
                            } else if (reportExtractData?.riskReportType == RiskReportType[2]?.value) { //Historical
                              return (
                                <div>
                                  <BarChart reportExtractData={reportExtractData} reportAxis={'y'} fundName={fundName} />
                                </div>
                              )
                            } else if (reportExtractData?.riskReportType == RiskReportType[3]?.value) { //Predictive
                              return (
                                <div>
                                  <BarChart reportExtractData={reportExtractData} reportAxis={'y'} fundName={fundName} />
                                </div>
                              )
                            } else if (reportExtractData?.riskReportType == RiskReportType[4]?.value) { //PayOff
                              return (
                                <div>
                                  <LineChart reportExtractData={reportExtractData} fundName={fundName} />
                                </div>
                              )
                            } else if (reportExtractData?.riskReportType == RiskReportType[5]?.value) { //Barra
                              return (
                                <div>
                                  <BarChart reportExtractData={reportExtractData} reportAxis={'y'} fundName={fundName} />
                                </div>
                              )
                            }
                          })()}
                        </div>
                        <div className="col-lg-8" >
                          <div style={{ backgroundColor: "#122e47", color: "white", fontSize: "8px" }}>
                            <div style={{ marginLeft: "70px", }}>
                              <p><b>View Name   :</b> {reportExtractData?.viewName}</p>
                              <p><b>Currency    :</b> {reportExtractData?.currency}</p>
                              <p><b>Portfoilo Name :</b>  {reportExtractData?.portfolioName}</p>
                              <p><b>As of Date   :</b> {moment(reportExtractData?.asOfDate).format("MM/DD/yyyy")}</p>
                              <p><b>Pricing Date  :</b>{moment(reportExtractData?.pricingDate).format("MM/DD/yyyy")}</p>
                              <p><b>Analysis Date :</b> {moment(reportExtractData?.analysisDate).format("MM/DD/yyyy")}</p>
                              <p><b> Submitted Date : </b>{moment(reportExtractData?.submitted).format("MM/DD/yyyy")}</p>
                              <p><b>Row Group :</b>{reportExtractData?.rowGroup}</p>
                            </div>
                          </div>
                          <div className="risk-report-table-box">
                            <table className="col-lg-12">
                              <thead>
                                <tr style={{ backgroundColor: "#122e47", }}>
                                  <td ></td>
                                  <td ></td>
                                  {reportExtractData?.header1.map((item) => {
                                    return (<td style={{ color: "white", fontSize: "9px" }}>{item}</td>)
                                  })}
                                </tr>
                                <tr style={{ backgroundColor: "#122e47" }}>
                                  <td></td>
                                  <td></td>
                                  {reportExtractData?.header2.map((item) => {
                                    return (<td style={{ color: "white", fontSize: "9px" }}>{item}</td>)
                                  })}
                                </tr>
                                <tr style={{ backgroundColor: "#122e47" }}>
                                  <td style={{ color: "white", fontSize: "9px" }}>Level</td>
                                  <td style={{ color: "white", fontSize: "9px" }}>Name</td>
                                  {reportExtractData?.header3.map((item) => {
                                    return (<td style={{ color: "white", fontSize: "9px" }}>{item}</td>)
                                  })}
                                </tr>
                                <tr style={{ backgroundColor: "#2db399" }}>
                                  <td style={{ color: "white" }}>-1</td>
                                  <td style={{ color: "white" }}>Totals</td>
                                  {reportExtractData?.totals?.map((item, index) => {
                                    return (<td style={{ color: "white" }}>{index == 0 && reportExtractData?.riskReportType === 0 ? item.toFixed(0) : item.toFixed(2)}</td>)
                                  })}
                                </tr>
                              </thead>

                              <tbody>
                                {reportExtractData?.riskValues?.map((item) => {
                                  return (
                                    <tr style={{ backgroundColor: getColor(item.level) }}>
                                      <td style={{ border: "1px solid white", fontSize: "9px" }}>{item.level}</td>
                                      <td style={{ border: "1px solid white", fontSize: "9px" }}>{item.name}</td>
                                      {item?.values?.map((value, index) =>
                                        <td style={{ border: "1px solid white", fontSize: "9px" }}>{index === 0 && reportExtractData?.riskReportType === 0 ? value?.toFixed(0) : value?.toFixed(2)}</td>
                                      )}
                                    </tr>
                                  )
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </TransformComponent>
            </React.Fragment>
          )}
        </TransformWrapper>
      ) :
        <div
          className="alert alert-primary text-center w-75 d-flex m-auto justify-content-center mt-5 mb-5"
          role="alert"
        >
         Risk Analytical Report is in Progress.
        </div>
      }
    </div>
  );
};

export default ReportTable;
